import {
    SET_CUSTOMER_INFO,
} from '../actions/types';

const INITIAL_STATE = {
    name: '',
    phone: '',
    email: '',
    tableLocation: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CUSTOMER_INFO:
            return action.payload ? { ...state, ...action.payload } : INITIAL_STATE;
        default:
            return state;
    }
};
